import { CountryCodeModel } from "../../model/country_code/CountryCodeModel";
import ApiService from "../../service/api/ApiService";
import ApiUrls from "../../service/api/ApiUrls";
import ShowToast from "../../widget/common/ui/Toast";

const CountryCodeProvider = new (class CountryCodeProvider {
  getCountryAPI = async (): Promise<CountryCodeModel | null> => {
    ApiUrls.init();

    const url: string = `${ApiUrls.baseUrl}geo/getCountryCodeList`;
    const body: any = {};

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const countryCodeListModel: CountryCodeModel = response;
        return countryCodeListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default CountryCodeProvider;
